import { useState, useEffect } from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import Icon from './Icon'
import { EXTENSION_URLS } from '../utils/constants'

const STORAGE_KEY = 'jobtrackr_extension_banner_dismissed'

export const ExtensionBanner = () => {
  const [dismissed, setDismissed] = useState(true) // Start hidden to avoid flash

  useEffect(() => {
    const isDismissed = localStorage.getItem(STORAGE_KEY) === 'true'
    setDismissed(isDismissed)
  }, [])

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true')
    setDismissed(true)
  }

  if (dismissed) return null

  return (
    <div className="relative rounded-lg border border-app-accent/30 p-4 pr-12 mb-4 bg-none bg-app-highlight">
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 p-1 text-app-muted hover:text-app-muted transition-colors"
        aria-label="Dismiss"
      >
        <XMarkIcon className="h-5 w-5" />
      </button>
      
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="text-sm font-semibold text-app-ink font-display">
              Save jobs with one click
            </h3>
          </div>
          <p className="text-xs text-app-muted">
            Install the browser extension to add jobs directly from LinkedIn, Indeed, and other job boards.
          </p>
        </div>
        
        <div className="flex flex-wrap items-center gap-2">
          <a
            href={EXTENSION_URLS.chrome}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-lg bg-app-surface/80 border border-app-line/50 px-3 py-2 text-xs font-medium text-app-muted hover:bg-app-surface hover:border-app-line transition-colors"
          >
            <Icon type="chrome" size={16} />
            Chrome
          </a>
          <a
            href={EXTENSION_URLS.firefox}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-lg bg-app-surface/80 border border-app-line/50 px-3 py-2 text-xs font-medium text-app-muted hover:bg-app-surface hover:border-app-line transition-colors"
          >
            <Icon type="firefox" size={16} />
            Firefox
          </a>
          <a
            href={EXTENSION_URLS.edge}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-lg bg-app-surface/80 border border-app-line/50 px-3 py-2 text-xs font-medium text-app-muted hover:bg-app-surface hover:border-app-line transition-colors"
          >
            <Icon type="edge" size={16} />
            Edge
          </a>
        </div>
      </div>
    </div>
  )
}
